import { useQuery } from '@tanstack/react-query';

import {
  DocumentFilters,
  getDocumentsForOrganization,
  getDocumentsForProject,
} from '@/features/documents/api/get-documents';
import { useDocumentsHubFilterStore } from '@/features/documents/components/pages/documents-hub-page';
import { useCurrentOrg } from '@/features/org/hooks/use-org';
import { SecureProjectDocument } from '@/shared/types/api';

export const orgaDocumentsQueryKey = (
  organizationId?: number,
  filters?: DocumentFilters,
) => ['documents', organizationId, filters ?? {}];

export const useDocuments = () => {
  const { data: org, isLoading: isOrgLoading } = useCurrentOrg();
  const filters = useDocumentsHubFilterStore();

  return useQuery({
    queryKey: orgaDocumentsQueryKey(org?.id, filters),
    queryFn: async () => {
      if (isOrgLoading || !org) {
        return [] as SecureProjectDocument[];
      }
      return getDocumentsForOrganization(org.id, filters);
    },
    enabled: !isOrgLoading && !!org,
  });
};

type ProjectDocumentsProps = {
  projectId: number;
  filters?: DocumentFilters;
};

export const projectDocumentsQueryKey = (
  projectId: number,
  filters?: DocumentFilters,
) => ['documents', projectId, filters ?? {}];

export const useProjectDocuments = ({
  projectId,
  filters,
}: ProjectDocumentsProps) => {
  return useQuery({
    queryKey: projectDocumentsQueryKey(projectId, filters),
    queryFn: async () => {
      return getDocumentsForProject(projectId, filters);
    },
  });
};
